import {ActionHandlerBase} from "../action-handler-base";
import {IOpenControlCenterMiniActionPayload} from "@sparkware/uc-sdk-core";

export class OpenControlCenterMiniActionHandler extends ActionHandlerBase<IOpenControlCenterMiniActionPayload> {
    async handle(payload: IOpenControlCenterMiniActionPayload): Promise<void> {
        if(await this.services.user.ensureUserIsLoggedIn('OpenControlCenterMiniActionHandler')) {
            (await this.services.userMenu).openMenu();
        }
    }

}